import { useCallback } from 'react';
import { Spinner } from 'components/elements/Spinner';
import FlyoutMenu from 'components/widgets/Dashboard/FlyoutMenu';
import Section from 'components/widgets/Dashboard/FlyoutMenu/Section';
import SectionItem from 'components/widgets/Dashboard/FlyoutMenu/SectionItem';
import SectionItemList from 'components/widgets/Dashboard/FlyoutMenu/SectionItemList';
import { useDashboardGroupName } from 'state/dashboard';
import { useSelectedSharedCollectionQuery } from 'state/queryParams';
import { CollectionSharedList } from 'types';
import { trackPageView } from 'utils/analytics';
import { SharedProjectsPageViewSections } from 'utils/analytics/constants';

type TCollectionListProps = {
  groups: CollectionSharedList[];
  loading?: boolean;
};

const CollectionList = ({ groups, loading }: TCollectionListProps) => {
  const [selectedGroup, setSelectedGroup] = useSelectedSharedCollectionQuery();
  const [, setGroupName] = useDashboardGroupName();
  const handleButtonClick = (id: number, name: string) => {
    setSelectedGroup?.(String(id));
    setGroupName?.(name);
    if (selectedGroup !== String(id)) {
      trackPageView({
        sectionName: SharedProjectsPageViewSections.SHARED_PROJECTS,
        subSectionName: String(id),
      });
    }
  };

  const isActive = useCallback(
    (id?: number) => id === Number(selectedGroup),
    [selectedGroup],
  );

  return (
    <FlyoutMenu>
      <Section title="Shared with me">
        <SectionItemList>
          {groups && !loading ? (
            groups.map(({ id, name, num_projects }) => (
              <SectionItem
                key={`shared-collection-menu-${id}`}
                label={name}
                numProjects={num_projects}
                isActive={isActive(id)}
                onClick={() => handleButtonClick(id && id, name)}
              />
            ))
          ) : (
            <Spinner size="sm" />
          )}
        </SectionItemList>
      </Section>
    </FlyoutMenu>
  );
};

export default CollectionList;
